export default __webpack_public_path__ + "static/media/files-icon.86c14f6c.png";